export default __webpack_public_path__ + "static/media/pagoefectivo_payment.81ba7fdd.png";